function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import LocationData from '../Location.context';
import LocationHoursAdd from './LocationHoursAdd.modal';
import LocationHoursSort from './LocationHoursSort.modal';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import Table from '../../common/table/Table.react';
var LocationHours = function LocationHours() {
  var dispatch = useDispatch();
  var _useContext = useContext(LocationData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var locationID = state._id,
    hours = state.hours,
    archived = state.archived;
  var columns = {
    id: {
      title: '_id',
      visible: false
    },
    label: 'Label',
    hours: 'Hours',
    slot: {
      title: 'Slot',
      size: 'contain',
      onClick: function onClick(_ref) {
        var row = _ref.row;
        if (archived) return;
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(LocationHoursSort, {
              locationID: locationID,
              hourID: row._id,
              hours: hours
            })
          }
        });
      }
    },
    remove: {
      title: 'Remove',
      size: 'contain',
      onClick: function onClick(_ref2) {
        var row = _ref2.row;
        if (archived) return;
        dispatch({
          type: ppcActions.location,
          payload: {
            formData: {
              locationID: locationID,
              hourID: row._id
            },
            method: 'delete',
            route: 'hours'
          }
        });
      }
    }
  };
  var data = (hours === null || hours === void 0 ? void 0 : hours.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return {
      _id: x._id,
      label: x.label,
      hours: x.hours,
      slot: x.slot,
      remove: 'Delete'
    };
  })) || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Location Hours",
    button: {
      label: 'Add',
      type: 'add',
      disabled: archived,
      onClick: function onClick() {
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(LocationHoursAdd, {
              locationID: locationID
            })
          }
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    sort: {
      by: 'slot'
    }
  })));
};
export default LocationHours;